define(
    'views/order-page-view',[
        'jquery',

        'modules/overlay-box',

        'connections/order-connection',

        'utils/view'
    ],

    function($, OverlayBox, OrderConnection, View) {
        var _this;

        var OrderPageView = (function() {
            function OrderPageView() {
                _this = this;
            }

            OrderPageView.prototype._init = function() {
                this.orderId = $('#order-container').data('order-id');
                this.initBindings();
            };


            OrderPageView.prototype.initBindings = function() {
                $('#openAsCart').on('click', this.openAsCartPopup);
            };


            OrderPageView.prototype.openAsCartPopup = function() {
                var ob = new OverlayBox($('#openAsCartPopup'), {});
                ob.setup();
                ob.load(function() {
                    $('#cancelConvert').one('click', function() { ob.destroy(); });
                    $('#continueConvert').one('click', _this.openAsCart);

                    ob.show();                    
                });
            };

            OrderPageView.prototype.openAsCart = function() {
                console.log('Create order clicked', _this.orderId);
                OrderConnection.loadAsCart(_this.orderId).then(function(res) {
                    if (typeof res === 'string') window.location.href = res;
                });
            };


            return OrderPageView;
        })();

        return View('OrderPageView', function () {
            var ov = new OrderPageView();
            ov._init();
        });
    }

);
